export enum PanelCardView{
    DefaultView = 0,
    AssignmentView = 1,
    WhereAmIUsedView = 2
}
